var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartDom",staticStyle:{"width":"300px","height":"300px"},attrs:{"id":"myEcharts"}})
}
var staticRenderFns = []

export { render, staticRenderFns }